import { combineReducers } from "redux";
import userReducer from "./userReducer";
import kenshiReducer from "./kenshiReducer";
import videoReducer from "./videoReducer";
import dojoReducer from "./dojoReducer";

const rootReducer = combineReducers({
  userReducer,
  kenshiReducer,
  videoReducer,
  dojoReducer
});

export default rootReducer;
